export const MAINMAP_TOP_SIDE_PORTAL_CONSTANT = 'MAINMAP_TOP_SIDE_PORTAL';
